(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/models/currentleagues.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/models/currentleagues.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.CurrentLeagues = Backbone.Model.extend({
    url: function() {
      return (
        svs.core.jupiter.url() +
        '/sport/1/teams/' +
        this.get('teamId') +
        '/current_leagues'
      );
    },
    defaults: function() {
      if (
        (((svs.statistics || {}).data || {}).teamModels || {}).currentleagues
      ) {
        return this.parse(svs.statistics.data.teamModels.currentleagues);
      }
    },
    initialize: function() {},
    parse: function(response) {
      var _self = this;
      if (response.leagues) {
        _.each(response.leagues, function(league) {
          if (league.isHomeLeague) {
            _self.set('homeLeague', league, { silent: true });
          }
        });
      }
      return response;
    }
  });
})(Backbone, _, svs);

 })(window);